import React from 'react';
import Header from './shared/Header';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
import { getRandomColor } from '../utils/colors';
const SaturdayCritiqueGroupPage = () => {
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-571" data-mp="1uyntvhtokbp0">
      <Header data-id="element-572" data-mp="1zxgx8hf96mbg" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-573" data-mp="1zvw2orsxv3dl">
        {/* Mobile Layout */}
        <div className="md:hidden w-full max-w-2xl mx-auto" data-id="element-574" data-mp="137zt46vx58bv">
          <h1 className="text-4xl font-bold mb-8 leading-tight" data-id="element-575" data-mp="178jnj2p3xxub">
            Saturday Critique Group 1
          </h1>

          <div className="text-base mb-8" data-id="element-576" data-mp="1c73b17jcnhos">
            <div className="font-bold mb-2" data-id="element-577" data-mp="1c6bg7yxktnzk">Dates:</div>
            <div data-id="element-578" data-mp="1h6zixhv63t9m">Starts 20th June, 2026</div>
            <div data-id="element-579" data-mp="1h80vjqru0ntg">Six Months, Meets Every Four Weeks</div>
            <div className="mb-4" data-id="element-580" data-mp="2nnky4h1247yr">Saturday from 9am - 11:30am EST</div>

            <div data-id="element-581" data-mp="2slw8csv9kkhi">Six Group Sessions & One 30-minute One-on-One Session</div>
            <div className="mb-4" data-id="element-582" data-mp="2snz844m7xrzf">
              (20th June, 18th July, 15th August, 12th September, 10th October,
              7th November)
            </div>

            <div className="mb-1" data-id="element-583" data-mp="3k9kj8dmmea47">
              <a href="https://www.paypal.com/ncp/payment/S2AB34WLEEV62" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-600 transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#2563eb';
            }} data-id="element-584" data-mp="3k6eqmoes8q3q">
                SOLD OUT
              </a>
            </div>
            <div className="italic mb-4" data-id="element-585" data-mp="2rkwqjwzjkigm">
              * Please email{' '}
              <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
              e.currentTarget.style.color = getRandomColor();
            }} onMouseLeave={e => {
              e.currentTarget.style.color = '#333333';
            }} data-id="element-586" data-mp="2mlacjlbw2y6r">
                mm@madeleinemorlet.com
              </a>{' '}
              if you are interested in joining Critique Group 2
            </div>

            <div className="font-bold mb-2" data-id="element-587" data-mp="22zqn7xl95w6r">Location:</div>
            <div data-id="element-588" data-mp="2qotfdzdij7fi">All sessions will take place over Zoom.</div>
            <div className="mb-4" data-id="element-589" data-mp="2qpbhvdqrqhvv">
              Class recordings and any assignments will be shared via email.
            </div>

            <div data-id="element-590" data-mp="2hw81awkttox0">Fee: $600 USD</div>
            <div className="mb-4" data-id="element-591" data-mp="2hv6oamk92scn">Refunds up to 30 days before the event.</div>

            <div data-id="element-592" data-mp="2lxbbb2g70qqb">Critique group limited to six attendees.</div>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/3ohKfEppVhBKFKp4Pg9jGM/03_MorletMadeleine_Bougainvillea.jpg" alt="Pink bougainvillea flowers" className="w-full h-auto mb-8" data-id="element-593" data-mp="39nfhnhkrn4l0" />

          <div className="text-base leading-relaxed space-y-4 mb-8" data-id="element-594" data-mp="12ydk0w9aij7b">
            <div className="font-bold mb-2" data-id="element-595" data-mp="y0by83khc5s5">Critique Group 1:</div>
            <p data-id="element-596" data-mp="xzsi8see3rgr">
              This new critique group offers a sustained and intimate structure
              for photographers who have an established practice and are looking
              for support as they continue developing ongoing projects or plan
              to begin new ones. The aim is to make meaningful work and build
              momentum alongside a thoughtful cohort of fellow artists.
              Participants can expect to present work monthly, and to be
              provided with (optional) writing exercises and inspiring
              photography prompts for between sessions.
            </p>
            <p data-id="element-597" data-mp="25dm2cau2e51o">
              Taking cues from the Iowa Writers' Workshop, participants will
              present their work for discussion without explanation, allowing
              them to 'see' it as others do. All group members will submit their
              images by the Wednesday prior to our sessions, giving them the
              opportunity to review one another's work in advance – and to
              arrive ready to offer generous and constructive feedback.
            </p>
            <p data-id="element-598" data-mp="j0gg4nf2jxe3">
              At the close of the six months, each participant will have a
              dedicated thirty-minute one-on-one with the instructor to reflect
              on their project's development and discuss its next steps.
            </p>
          </div>

          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-599" data-mp="xtjp46elh2t7" />

          <div className="text-base leading-relaxed" data-id="element-600" data-mp="16pivfom8de5f">
            <div className="font-bold mb-2" data-id="element-601" data-mp="1bo3xltl1m7wi">Instructor:</div>
            <p data-id="element-602" data-mp="1glm99rqg3187">
              Madeleine Morlet is a British-American photographer based in
              London. Her teaching centers on the narrative potential of
              photography and the photobook form, informed by her background in
              filmmaking and creative writing. She combines editorial feedback
              with practical strategy to help students both refine their vision
              and sustain creative practices, guiding them toward publication.
              An award-winning photographer recognised by institutions including
              PhotoVogue and the Lucie Foundation, she brings both professional
              experience and artistic insight into the classroom.
            </p>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-row w-full max-w-6xl mx-auto gap-12" data-id="element-603" data-mp="1zo4nesw9wwvl">
          <div className="w-full md:w-1/2 flex flex-col gap-8" data-id="element-604" data-mp="1vmt4f67wn9wd">
            <img src="https://cdn.magicpatterns.com/uploads/3ohKfEppVhBKFKp4Pg9jGM/03_MorletMadeleine_Bougainvillea.jpg" alt="Pink bougainvillea flowers" className="w-full h-auto" data-id="element-605" data-mp="2s7tl4h7xp6gi" />

            <div className="flex-1 flex flex-col justify-end" data-id="element-606" data-mp="lkm8tbbn6f7f">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-607" data-mp="qgb24wx2izva" />

              <div className="text-base leading-relaxed" data-id="element-608" data-mp="gpgf3qbzzw8s">
                <div className="font-bold mb-2" data-id="element-609" data-mp="2r8os19gvt6l">Instructor:</div>
                <p data-id="element-610" data-mp="7rnymiujiijt">
                  Madeleine Morlet is a British-American photographer based in
                  London. Her teaching centers on the narrative potential of
                  photography and the photobook form, informed by her background
                  in filmmaking and creative writing. She combines editorial
                  feedback with practical strategy to help students both refine
                  their vision and sustain creative practices, guiding them
                  toward publication. An award-winning photographer recognised
                  by institutions including PhotoVogue and the Lucie Foundation,
                  she brings both professional experience and artistic insight
                  into the classroom.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-611" data-mp="3hmirfy2gqxku">
            <div className="max-w-2xl" data-id="element-612" data-mp="3vfi843dzextz">
              <h1 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-613" data-mp="3ve71lvt5jbz6">
                Saturday Critique Group 1
              </h1>

              <div className="text-base mb-8" data-id="element-614" data-mp="3rg9agnftmft5">
                <div className="font-bold mb-2" data-id="element-615" data-mp="978rowm1q4g8">Dates:</div>
                <div data-id="element-616" data-mp="49790csj875a">Starts 20th June, 2026</div>
                <div data-id="element-617" data-mp="4aicebi2fcvv">Six Months, Meets Every Four Weeks</div>
                <div className="mb-4" data-id="element-618" data-mp="2azes1qhivff4">Saturday from 9am - 11:30am EST</div>

                <div data-id="element-619" data-mp="2b1hu58vy8z07">Six Group Sessions & One 30-minute One-on-One Session</div>
                <div className="mb-4" data-id="element-620" data-mp="262emdgol4eoj">
                  (20th June, 18th July, 15th August, 12th September, 10th
                  October, 7th November)
                </div>

                <div className="mb-1" data-id="element-621" data-mp="1p56gr81nhkzr">
                  <a href="https://www.paypal.com/ncp/payment/S2AB34WLEEV62" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-600 transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#2563eb';
                }} data-id="element-622" data-mp="1p44ue7f6pc2q">
                    SOLD OUT
                  </a>
                </div>
                <div className="italic mb-4" data-id="element-623" data-mp="2mm552fcfsca3">
                  * Please email{' '}
                  <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-624" data-mp="2rkyarllheyzp">
                    mm@madeleinemorlet.com
                  </a>{' '}
                  if you are interested in joining Critique Group 2
                </div>

                <div className="font-bold mb-2" data-id="element-625" data-mp="3scx1lrakh9jg">Location:</div>
                <div data-id="element-626" data-mp="3ocmw0fqosl54">All sessions will take place over Zoom.</div>
                <div className="mb-4" data-id="element-627" data-mp="3je3c0kvnljfe">
                  Class recordings and any assignments will be shared via email.
                </div>

                <div data-id="element-628" data-mp="3egta45r2vfao">Fee: $600 USD</div>
                <div className="mb-4" data-id="element-629" data-mp="1hmyi1i6906rw">
                  Refunds up to 30 days before the event.
                </div>

                <div data-id="element-630" data-mp="1cndlfeejwaic">Critique group limited to six attendees.</div>
              </div>

              <div className="text-base leading-relaxed space-y-4" data-id="element-631" data-mp="2uwfp79t9f080">
                <div className="font-bold mb-2" data-id="element-632" data-mp="2uysigj4gwx0d">Critique Group 1:</div>
                <p data-id="element-633" data-mp="2pwteb70wlw2d">
                  This new critique group offers a sustained and intimate
                  structure for photographers who have an established practice
                  and are looking for support as they continue developing
                  ongoing projects or plan to begin new ones. The aim is to make
                  meaningful work and build momentum alongside a thoughtful
                  cohort of fellow artists. Participants can expect to present
                  work monthly, and to be provided with (optional) writing
                  exercises and inspiring photography prompts for between
                  sessions.
                </p>
                <p data-id="element-634" data-mp="1shfg9d5eg1k3">
                  Taking cues from the Iowa Writers' Workshop, participants will
                  present their work for discussion without explanation,
                  allowing them to 'see' it as others do. All group members will
                  submit their images by the Wednesday prior to our sessions,
                  giving them the opportunity to review one another's work in
                  advance – and to arrive ready to offer generous and
                  constructive feedback.
                </p>
                <p data-id="element-635" data-mp="19dvlzt3p6t84">
                  At the close of the six months, each participant will have a
                  dedicated thirty-minute one-on-one with the instructor to
                  reflect on their project's development and discuss its next
                  steps.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default SaturdayCritiqueGroupPage;